<template>
    <!-- 课程选择页面 -->
    <el-dialog :title="addInvestigationTitle"
               :visible="dialogVisible"
               :before-close="dialogClose"
               width="52%">
        <div class="mod-rm__coursevehiclerela" >
            <el-card shadow="never"
                     class="aui-card--fill">
                <el-form :inline="true"
                         :model="dataForm"
                         label-position="left"
                         label-width="100px">
                    <el-row :gutter="10">
                        <!-- 问卷名称 -->
                        <el-col :span="18">
                            <el-form-item :label="$t('offering.investigationName')"
                                          style="width: 98%!important;">
                                <el-input v-model="dataForm.investigationName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item style="float: right">
                                <el-button type="primary"
                                           @click="queryCourse()">{{ $t('query') }}</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item style="float: right">
                                <el-button class="el-back"
                                           type="info"
                                           @click="resetQueryData()">{{ $t('reset') }}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">

                    </el-row>
                </el-form>
                <div class="search">
                    <!-- 确定按钮 -->
                    <el-button style="margin-bottom: 7px"
                               type="primary"
                               @click="confirmBtn">{{ $t('confirm') }}</el-button>
                    <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;* 如需选择新增的问卷，请联系BMW.CallCenter@bmw-brilliance.cn 或 400-024-7666。</span>
                </div>
                <el-table :data="dataList"
                          @select="selectRedio"
                          border
                          size="mini"
                          class="jySelectionAll"
                          v-loading="dataListLoading"
                          ref="investigationTable"
                          style="width: 100%;">
                    <el-table-column type="selection"
                                     align="center"
                                     width="50px">
                    </el-table-column>
                    <!-- 问卷编号  -->
                    <el-table-column prop="investigationId"
                                     :label="$t('offering.investigationId')"
                                     header-align="center"
                                     :show-overflow-tooltip="true"
                                     width="180"
                                     align="center"></el-table-column>
                    <!-- 问卷名称 -->
                    <el-table-column prop="investigationName"
                                     :label="$t('offering.investigationName')"
                                     header-align="center"
                                     :show-overflow-tooltip="true"
                                     width="180"
                                     align="center"></el-table-column>
                    <!-- 问卷地址 -->
                    <el-table-column prop="investigationAddress"
                                     :label="$t('offering.investigationAddress')"
                                     header-align="center"
                                     :show-overflow-tooltip="true"
                                     align="center">
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="sizeChangeHandle"
                               @current-change="currentChangeHandle"
                               :current-page="page"
                               :page-sizes="[10, 20, 50, 100]"
                               :page-size="page"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total">
                </el-pagination>
            </el-card>
        </div>
    </el-dialog>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  props: {
    dialogVisible: Boolean,
    dialogFlag: String
  },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/learning/learninginvestigationlist/page',
        getDataListIsPage: true
      },
      dataForm: {
        investigationName: '',
        investigationId: '',
        investigationType: '20'
      },
      courseDataList: [],
      dataList: [],
      offeringDataList: [],
      page: 1, // 当前页码
      limit: 10, // 每页数
      total: 0, // 总条数deleteURL
      dataListLoading: false,
      addInvestigationTitle: '',
      initQuestionnaireData: {}
    }
  },
  created () {
    this.mixinViewModuleOptions.getDataListURL = '/learning/learninginvestigationlist/page'
    this.mixinViewModuleOptions.getDataListIsPage = true
    this.getDataList()
    let resdata = this.dataList
    resdata.forEach(item => {
      item.checked = false
    })
    this.dataList = resdata
  },
  mounted () {
    console.log('打开窗体')
    this.getDataList()
  },
  methods: {
    initMethods (initData) {
      this.dialogVisible = true
      this.initQuestionnaireData = initData

      let selectRow = []
      this.addInvestigationTitle = '选择培训师问卷'
      selectRow = this.initQuestionnaireData.trainerInvestigationList
      // 回显勾选
      this.querySelect(selectRow)
    },
    dialogClose () {
      this.$emit('courseTrainerDialogClose')
    },
    confirmBtn () {
      let select = this.$refs.investigationTable.selection
      if (select.length <= 0) {
        this.$message.warning(this.$t('offering.select'))
        return false
      }
      this.$emit('confirmCourseTrainerBtn', select, this.dialogFlag)
      this.$refs.investigationTable.clearSelection()
    },
    // 每页数
    sizeChangeHandle (val) {
      this.limit = val
      this.page = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.page = val
      this.getDataList()
    },
    // 单选
    selectRedio: function selectRedio (selection, row) {
      if (this.$refs.investigationTable.selection.length > 1) {
        this.$refs.investigationTable.clearSelection()
        this.$refs.investigationTable.toggleRowSelection(row)
      }
    },
    // 重置查询条件
    resetQueryData () {
      this.dataForm = {
        investigationName: '',
        investigationId: '',
        investigationType: '20'
      }
      this.queryCourse()
    },
    queryCourse () {
      console.log('打开窗体')
      this.page = 1
      this.getDataList()
    },
    // 打开页面时，回填勾选
    querySelect (selectRow) {
      console.log(selectRow)
      this.$refs.investigationTable.clearSelection()
      if (selectRow.length > 0) {
        let self = this
        self.dataList.forEach(function (dataItem, dataindex) {
          if (selectRow[0].investigationId === dataItem.investigationId) {
            self.$refs.investigationTable.toggleRowSelection(dataItem, true)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
    /* 隐藏网格的全选按钮 */
    .jySelectionAll
    > .el-table__header-wrapper
    > .el-table__header
    > thead
    > tr
    > th
    > .cell
    > label {
        display: none !important;
    }
</style>
